import { InsuranceType, MainPath } from "Constants/constants";

import { useTexts } from "Components/TextContext";
import { Species } from "Store/interfaces/products/checkout/riskProducts/AnimalProduct";
import { AnimalProductIntroFormValues } from "./animalInterfaces";

export const PRODUCT_PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.ANIMAL}`;
export const DEFAULT_COVERAGE_AMOUNT_DEATH = 15000;
export const DEFAULT_COVERAGE_AMOUNT_VET = 15000;

export const NO_VET_OR_INJURIES_PREFIX = "{{{withoutVetAndInjuries}}}";
export const ACTUAL_PAYLOAD_PREFIX = "{{{actualPayload}}}";

export const MAX_SUM_DEATH = 40000;
export const MIN_SUM_DEATH_CAT = 5000;
export const MIN_SUM_DEATH_DOG = 8000;

export const getMinSumDeathForAnimal = (species: Species): number => {
  if (species === Species.CAT) {
    return MIN_SUM_DEATH_CAT;
  }
  return MIN_SUM_DEATH_DOG;
};

export const getMinSumDeathValidationText = (species: Species): string => {
  const { getText } = useTexts();
  if (species === Species.CAT) {
    return getText("animalform.validation.coverageamountdeathcat");
  }
  return getText("animalform.validation.coverageamountdeathdog");
};

export enum CoverageAmountVetOption {
  ZERO = "10000",
  ONE = "15000",
  TWO = "20000",
  THREE = "30000",
  FOUR = "40000",
  FIVE = "50000",
}

export const ANIMAL_PRODUCT_INTRO_INITIAL_FORM_VALUES: Partial<AnimalProductIntroFormValues> =
  {
    species: undefined,
    microchipped: undefined,
    dateOfBirth: undefined,
    insuranceShouldBeTransferredFromAnotherCompany: undefined,
    breed: "",
    injuries: undefined,
    injuryYear: undefined,
    isAllowedWithVet: undefined,
  };
